import { camelCaseSearchParams } from '@/config/searchParams';
import type { UrlQuizConfig } from '@/modules/quiz/onboardingSettings';
import { emptyMetadata, type ConfigMetadata, type RemoteConfigProvider } from './types';

const KEYS = ['onboardingVariant', 'popupVariant', 'config', 'instantAppEnabled'] as const;

/** Port of WebQuiz `UrlProvider`: camelCase query → known keys. */
export class UrlConfigProvider implements RemoteConfigProvider<UrlQuizConfig> {
  readonly binding = 'urlProvider' as const;
  private value: UrlQuizConfig = {};
  readonly metadata: ConfigMetadata = emptyMetadata('url');

  constructor(private readonly search: string | URLSearchParams) {}

  async init(): Promise<void> {
    const all = camelCaseSearchParams(this.search);
    const config: UrlQuizConfig = {};
    for (const key of KEYS) if (typeof all[key] === 'string') config[key] = all[key];
    this.value = config;
    this.metadata.config = config as Record<string, unknown>;
    this.metadata.validity = true;
  }

  get config(): UrlQuizConfig {
    return this.value;
  }
}
